import { render } from "./FormularioCotizacion.vue?vue&type=template&id=ed8c0630&scoped=true"
import script from "./FormularioCotizacion.vue?vue&type=script&lang=js"
export * from "./FormularioCotizacion.vue?vue&type=script&lang=js"

import "./FormularioCotizacion.vue?vue&type=style&index=0&id=ed8c0630&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed8c0630"]])

export default __exports__